// handles setting and removing a flag in session storage which will render a warning message during the sign up
// process if a user tries to spoof an invite to gain unauthorized access to an org, or if something otherwise gets
// wonky with an invite somehow

export const unauthorizedInvite = sessionStorage.getItem('unauthorizedInvite');
export const clearUnauthorizedInviteWarning = () => sessionStorage.removeItem('unauthorizedInvite');
export const setUnauthorizedInviteWarning = () => sessionStorage.setItem('unauthorizedInvite', 'true');
